/* Copyright (c) 2018 Scaper */

import { parse, stringify } from "query-string";
import { RouteComponentProps } from "react-router";
import { APP_PATH } from "../appPath";

export interface ISetPhoneNumberRouteParams {
    from?: string;
}

export const SET_PHONE_NUMBER_PATH = `${APP_PATH}/set-phone-number`;

export const SetPhoneNumberPath = {
    of: (params?: ISetPhoneNumberRouteParams) => {
        const queryString = params != null ? `?${stringify(params)}` : "";
        return `${SET_PHONE_NUMBER_PATH}${queryString}`;
    },
    parse: (props: RouteComponentProps<ISetPhoneNumberRouteParams>) => {
        const pathParams = props.match.params;
        const queryParams = parse(props.location.search);
        return { ...pathParams, ...queryParams };
    },
};
